import {Button, Dropdown, Tooltip} from 'antd';
import moment from 'moment-timezone';
import React from 'react';

import {findIconDefinition} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {IconWrapper} from '../../IconWrapper';
import {SnoozeMenu} from './SnoozeMenu';
import {defaultSnoozeTime, SnoozeOptions} from './utils';
import './SnoozeButton.scss';

export const SnoozeButton = ({conversation, snoozeConversation, toggleArchived}: any) => {
  const [snoozeDatePickerOpen, setSnoozeDatePickerOpen] = React.useState(false);
  const [snoozeDropdownVisible, setSnoozeDropdownVisible] = React.useState(false);
  const snoozeDatePickerStatus = status => {
    if (!status) {
      setSnoozeDatePickerOpen(false);
    }
  };
  const snoozeConversationWrapper = (id, time) => {
    setSnoozeDatePickerOpen(false);
    snoozeConversation(id, time);
  };
  const setCustomSnoozeTimer = (value?: any) => {
    if (!value) {
      snoozeConversationWrapper(conversation.id, null);
    } else {
      const snoozeTime = value.set('hour', 9).utc(true).format();
      snoozeConversationWrapper(conversation.id, snoozeTime);
    }
    if (conversation.archived) {
      toggleArchived();
    }
  };

  const setSnoozeTimer = event => {
    if (event.key === SnoozeOptions.Custom) {
      setSnoozeDatePickerOpen(true);
      return;
    }
    const today = moment();
    let until;
    switch (event.key) {
      case SnoozeOptions.Tomorrow:
        until = today.add(1, 'day');
        until = until.set(defaultSnoozeTime);
        break;
      case SnoozeOptions.NextMonday:
        until = today.startOf('isoWeek').add(1, 'week').day('monday');
        until = until.set(defaultSnoozeTime);
        break;
      case SnoozeOptions.InOneWeek:
        until = today.add(1, 'week');
        until = until.set(defaultSnoozeTime);
        break;
      case SnoozeOptions.InOneMonth:
        until = today.add(1, 'month');
        until = until.set(defaultSnoozeTime);
        break;
      case SnoozeOptions.LaterToday: // in 3 hours
      default:
        until = today.add(3, 'hours');
    }
    snoozeConversationWrapper(conversation.id, until.tz('UTC').format());
    if (conversation.archived) {
      toggleArchived();
    }
  };

  if (conversation.snoozed_until) {
    return (
      <Tooltip title={'Unsnooze'}>
        <Button
          className="snooze_button enabled"
          onClick={() => setCustomSnoozeTimer()}
          style={{marginLeft: 5}}
          type="dashed"
        >
          <IconWrapper>
            <FontAwesomeIcon
              icon={findIconDefinition({
                prefix: 'fas',
                iconName: 'clock',
              })}
            />
          </IconWrapper>
        </Button>
      </Tooltip>
    );
  } else {
    return (
      <Dropdown
        overlayClassName="conversation__snooze-dropdown"
        overlay={
          <SnoozeMenu
            setSnoozeTimer={setSnoozeTimer}
            setSnoozeDropdownVisible={setSnoozeDropdownVisible}
            snoozeDatePickerOpen={snoozeDatePickerOpen}
            snoozeDatePickerStatus={snoozeDatePickerStatus}
            setCustomSnoozeTimer={setCustomSnoozeTimer}
          />
        }
        placement="top"
        open={snoozeDropdownVisible}
      >
        <Tooltip title={' Snooze'}>
          <Button
            onClick={() => setSnoozeDropdownVisible(!snoozeDropdownVisible)}
            style={{marginLeft: 5}}
            type="dashed"
            className="snooze_trigger"
          >
            <IconWrapper>
              <FontAwesomeIcon icon={findIconDefinition({prefix: 'fas', iconName: 'clock'})}/>
            </IconWrapper>
          </Button>
        </Tooltip>
      </Dropdown>
    );
  }
};
